module.exports = __webpack_public_path__ + "static/media/scroll-down.007459ef.svg";